/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TourTypeEnum } from './tourTypeEnum';
import { TourRequestContact } from './tourRequestContact';
import { TourRequestOrder } from './tourRequestOrder';


export interface TourRequest { 
    name?: string | null;
    type: TourTypeEnum;
    /**
     * Ostatní.
     */
    tourDate: string;
    signatureLocation?: string | null;
    masterNotes?: string | null;
    formType: string;
    commissionKc?: string | null;
    commissionPercent?: string | null;
    contact?: TourRequestContact;
    order: TourRequestOrder;
}
export namespace TourRequest {
}


